<template>
  <Modal
    :show="show"
    class="modal-window"
    :onClose="onClose"
    position="center-center"
    :disableOutsideClick="true"
    :disableEscapeKey="true"
  >
    <div class="center-align">
      <div class="modal-background">
        <div class="custom-label">
          <img class="lock-icon" src="@/assets/images/privacy_policy_lock.png">
        </div>
        <div class="heading">
          {{$t('register.new_reg_title_with_bypass')}}
        </div>
        <div class="description">
          <input id="privacyPolicyModalAgreementCheckBox" type="checkbox" class="consent-checkbox" name="consentBool" v-model="consentForPolicyAndTerms">
          <label class="consent-label" v-html="$t('register.privacy_policy_and_tos', { url: privacyPolicyLink(), tosUrl: termsOfServiceLink() })">
          </label>
        </div>
        <div>
          <button :class="{ disable: !consentForPolicyAndTerms }" :disabled="!consentForPolicyAndTerms" class="custom-button continue-btn" id="continue" @click="onContinue">{{$t('login.continue')}}</button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script setup>
import { ref } from 'vue';
import Modal from '@/components/ui/Modal';
import { GetPreferredLanguage } from '@/utils/helper';

// component name
defineOptions({
  name: 'modal-window'
});

// Props
const props = defineProps({
  show: { type: Boolean, required: true },
  onClose: { type: Function, default: () => {} },
  onContinue: { type: Function, default: () => {} }
});

// Reactive data
const consentForPolicyAndTerms = ref(false);

// Methods
const privacyPolicyLink = () => {
  return `https:\/\/www.netroadshow.com/nrs/home/${GetPreferredLanguage()}/privacy-policy.html`;
};

const termsOfServiceLink = () => {
  return `https:\/\/www.netroadshow.com/nrs/home/${GetPreferredLanguage()}/terms-of-service.html`;
};
</script>

<style lang="stylus" scoped>
.center-align {
  text-align: center;
}
.custom-label {
  margin: 0 15px 30px;
  display: inline-table;
  width: 36px;
  height: 36px;
  background: #285298;
  border-radius: 20px;
}
.heading {
  margin: 0 0 20px 0;
  font-weight: bold;
  font-size: 18px;
  font-family: 'Roboto', sans-serif !important;
}
.description {
  margin: 0 0 40px 0;
  font-size: 14px;
  font-family: 'Roboto', sans-serif !important;
  color: #3d3d3d;
}
.custom-button {
  display: inline-block;
  border-radius: 3px;
  border: none;
  outline: none;
  text-align: center;
  font-size: 0.9375rem;
  text-decoration: none;
  color: #fff;
  width: 215px;
  height: 44px;
  background: #285298;
  cursor: pointer;
  outline: none;
  &:disabled {
      cursor: no-drop;
  }
  @media (min-width: 767px) {
      min-width: 150px;
  }
}
.hyperlink:hover  {
  text-decoration: underline;
}
.continue-btn {
  width: 100%;
  max-width: 88px;
  margin: 0px;
  font-size: 14px;
  font-family: 'Roboto', sans-serif !important;
  background: var(--primary-color);
  box-shadow: rgb(221, 221, 221) 0px 3px 3px -2px
  border-radius: 3px;
  &:hover {
    background: var(--primary-color-dark);
  }
  &:active {
    background-color: var(--primary-color-darker);
  }
}
.modal-window {
  background: rgba(0,0,0,0.75) !important;
  padding: 0 8.333333333333334%;
  @media screen and (max-width: 768px) {
      padding 0 15px;
  }
  & :deep(.modal-content) {
    border: none;
    box-shadow: none;
    border-radius: 4px;
    max-width: 525px;
    min-height: 290px;
    padding: 45px;
    width: 100%;
    height: auto;

    @media (max-width: 996px) {
      width: 80%;
    }

    @media (max-width: 768px) {
      width: 100%;
    }
  }
  .modal-background {
    background-color: #fff;
  }
}

.lock-icon {
  height: 22px;
  margin-top:8px;
}
.consent-label {
  vertical-align: text-top;
}
    .consent-checkbox {
      height: 16px;
      width: 16px;
      vertical-align: middle;
    }
  .disable {
    opacity: 0.5;
  }
</style>


